import React from 'react'
import StatusIcon from '../../Icons/StatusIcon'
import loadable from '@loadable/component';
import APIS from "../../constant/EndPoint";
const NotificationListComponent = loadable(
  () => import("../../components/Notification/NotificationList")
);

//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePostHook from '../../customHooks/usePostHook';
import NotificationIcon from '../../Icons/NotificationIcon';
const NotificationList = () => {
  const { mutateAsync } = usePostHook({
    queryKey: ["notifications"],
    navigateURL: "",
  });


  const handleRead = async (id: string, read: Boolean) => {
    const url = `${APIS.NOTIFICATION}${read ? "read" : "unread"}/`;
    let formData = {
      ids: [id]
    };
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }


  const handleDelete = async (id: string) => {
    const url = `${APIS.NOTIFICATION}delete/`;
    let formData = {
      ids: [id]
    };
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    
     <div className={tw``}>
      <div className={tw`flex  gap-x-2 mb-6 uppercase font-extrabold`}>
        <NotificationIcon/>
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Notifications</span>
      </div>
      <NotificationListComponent
        handleRead={handleRead}
        handleDelete={handleDelete}
      />
      </div>
    
    
  );
};

export default NotificationList;
